import { Dispatch } from "redux";
import {
  getRoles,
  createRole,
  updateRole,
  deleteRole,
} from "../../services/RolesService";
import { RoleMaster } from "./authUserActions";

// Action Types
export enum RoleActionType {
  FETCH_ROLES = "FETCH_ROLES",
  ADD_ROLE = "ADD_ROLE",
  EDIT_ROLE = "EDIT_ROLE",
  DELETE_ROLE = "DELETE_ROLE",
}

// Action Interfaces
export interface FetchRoleAction {
  type: RoleActionType.FETCH_ROLES;
  data: RoleMaster[];
}

export interface AddRoleAction {
  type: RoleActionType.ADD_ROLE;
  data: RoleMaster;
}

export interface EditRoleAction {
  type: RoleActionType.EDIT_ROLE;
  data: RoleMaster;
}

export interface DeleteRoleAction {
  type: RoleActionType.DELETE_ROLE;
  data: number;
}

export type RoleAction =
  | FetchRoleAction
  | AddRoleAction
  | EditRoleAction
  | DeleteRoleAction;

export const fetchRoles = () => async (dispatch: Dispatch) => {
  const data = await getRoles();

  const mappedData = data.map((item: any) => ({
    id: item.id,
    roleName: item.roleName, 
    status: item.status,
  }));

  dispatch<FetchRoleAction>({
    type: RoleActionType.FETCH_ROLES,
    data: mappedData,
  });
};

// CREATE
export const addRole = (role: RoleMaster) => async (dispatch: Dispatch) => {
  const response = await createRole(role);

  const apiData = response.data.data;

  dispatch<AddRoleAction>({
    type: RoleActionType.ADD_ROLE,
    data: {
      id: apiData.id,
      roleName: apiData.roleName, 
      status: apiData.status,
    },
  });
};

// UPDATE
export const editRole =
  (id: number, role: RoleMaster) => async (dispatch: Dispatch) => {
    const response = await updateRole(id, role);

    const apiData = response.data.data;

    dispatch<EditRoleAction>({
      type: RoleActionType.EDIT_ROLE,
      data: {
        id: apiData.id,
        roleName: apiData.roleName, 
        status: apiData.status,
      },
    });
  };

// DELETE
export const deleteRoleById = (id: number) => async (dispatch: Dispatch) => {
  await deleteRole(id);
  dispatch<DeleteRoleAction>({
    type: RoleActionType.DELETE_ROLE,
    data: id,
  });
};